window.addEventListener('load', function () {
  const carouselSlides = document.querySelectorAll('.fullwidth-carousel-slide');

  if (1 < carouselSlides.length) {
    const Swiper = window.Swiper;
    new Swiper('.fullwidth-carousel', {
      direction: 'horizontal',
      loop: true,
      slidesPerView: 1,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      autoplay: {
        delay: 5000,
      },
      keyboard: true,
      pagination: {
        el: '.fullwidth-carousel .swiper-pagination',
        clickable: true,
      },
      on: {
        afterInit: function () {
          let currentSlide = this.slides[this.activeIndex];
          this.$el[0].setAttribute(
            'data-current-contrast',
            currentSlide.getAttribute('data-contrast')
          );
        },
        slideChange: function () {
          let currentSlide = this.slides[this.activeIndex];
          this.$el[0].setAttribute(
            'data-current-contrast',
            currentSlide.getAttribute('data-contrast')
          );
        },
      },
    });
  } else if (1 === carouselSlides.length) {
    carouselSlides[0].classList.add('single-slide-loaded');
  }
});
